import type { AuthTypes } from '@/common/types/auth.types';

export const AuthInitialState: AuthTypes = {
  jwtToken: null,
  userId: null,
  error: null,
  tokenVerification: null,
  incidentGatheringId: null,
  incidentViewingId: null,
  activeCountyId: null,
};
